import { render, staticRenderFns } from "./SalesLogShow.vue?vue&type=template&id=40891e1d&"
import script from "./SalesLogShow.vue?vue&type=script&lang=js&"
export * from "./SalesLogShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports